import { useCallback, useRef, useState } from 'react';
import { NaverMap, Marker, Container as MapDiv, NavermapsProvider } from 'react-naver-maps';

import { CmsSellerFilters, CustomCmsSeller } from '../../../../domain/seller';
import ListSellers from '../ListSellers';
import SellerPageStructure from '../SellerPageStructure';
import { scrollToSeller, setInfoWindowContent } from '../helper';
import NaverMapSellersFiltersMap from './NaverMapSellersFiltersMap';
import { gtmPush } from '../../../utils/gtmHelpers';

// import useSellersNaverMap from './useSellersNaver';

type NaverMapSellersPageProps = {
  sellers: CustomCmsSeller[];
  onSubmitFilterForm: (value: CmsSellerFilters) => void;
  filters: CmsSellerFilters;
};

const NaverMapSellersPage = ({
  sellers,
  onSubmitFilterForm,
  filters,
}: NaverMapSellersPageProps) => {
  const [selectedStore, setSelectedStore] = useState<CustomCmsSeller>();
  const filtersRef = useRef(filters);
  filtersRef.current = filters;
  const isMobile = window.innerWidth < 960

  let infoWindow;

  const mapRef = useRef<naver.maps.Map | null>(null);
  // const { mapRef, markersRef } = useSellersNaverMap(sellers, {
  //   onClickMarker: (seller) => {
  //     setSelectedStore(seller)
  //     scrollToSeller(seller)
  //   },
  //   onZoomChange(map) {
  //     const zoom = map.getZoom()
  //     if (zoom && zoom < 11 && filtersRef.current.radius) {
  //       onSubmitFilterForm({
  //         ...filtersRef.current,
  //         radius: undefined,
  //       })
  //     }
  //   },
  // })

  const centerMapFromLatLng = useCallback(
    (lat: number, lng: number, zoom = 12) => {
      centerMapToCoordinates(lat, lng, zoom)
    },
    [mapRef],
  );

  const centerMapToCoordinates = (lat: number, lng: number, zoom = 12, offsetX = 0, offsetY = 0) => {
    if (mapRef.current) {
      console.log("center maps", lat, lng, zoom, offsetX, offsetY);

      // Create the target LatLng position
      const targetPosition = new naver.maps.LatLng(lat, lng);

      // Pan the map to the target position with an offset
      mapRef.current.setCenter(targetPosition);
      mapRef.current.setZoom(zoom);

      if(!isMobile){
        return;
      }

      // After panning, apply the offset by re-centering
      const mapSize = mapRef.current.getSize();
      const projection = mapRef.current.getProjection();

      if (projection && mapSize) {
        const point = projection.fromCoordToOffset(targetPosition);

        // Calculate new point with offset adjustments
        const offsetPoint = new naver.maps.Point(
          point.x - (mapSize.width / 2 - offsetX),
          point.y - (mapSize.height / 2 - offsetY)
        );

        // Convert the new point back to LatLng and re-center
        const newCenter = projection.fromOffsetToCoord(offsetPoint);
        mapRef.current.setCenter(newCenter);
        mapRef.current.setZoom(zoom);
      }
    }
  };

  const onSelectStore = (seller: CustomCmsSeller) => {
    setSelectedStore(seller);
    gtmPush({ event: 'select_boutique' });

    // Center the map on the selected store
    centerMapToCoordinates(Number(seller.latitude), Number(seller.longitude), 15, 0, 40);
    openInfoWindow(seller);
  };

  const openInfoWindow = (seller: CustomCmsSeller) => {
    infoWindow = new naver.maps.InfoWindow({
      maxWidth: 300,
      position: new naver.maps.LatLng(Number(seller.latitude), Number(seller.longitude)),
      content: `
        <div style="padding: 10px;">
          ${setInfoWindowContent(seller)}
        </div>
      `,
      /*maxWidth: 140,
      backgroundColor: "#eee",
      borderColor: "#2db400",
      borderWidth: 5,
      anchorSize: new window.N.Size(30, 30),
      anchorSkew: true,
      anchorColor: "#eee",

      pixelOffset: new window.N.Point(20, -20)*/
    });
    infoWindow.open(mapRef.current);

    if (mapRef.current) {
      naver.maps.Event.addListener(mapRef.current, 'click', () => {
        // Close the InfoWindow when the map is clicked
        infoWindow.close();
      });
    }
  }

  return (
    <NavermapsProvider
      ncpClientId={process.env.NEXT_PUBLIC_NAVER_MAP_CLIENT_ID ?? ''} // your Naver Cloud Platform client ID
      submodules={['panorama', 'overlay', 'geocoder']}
    >
      <SellerPageStructure>
        <NaverMapSellersFiltersMap
          centerMapFromLatLng={centerMapFromLatLng}
          onSubmitFilterForm={onSubmitFilterForm}
          hasCitySearch={true}
        />
        <MapDiv className={"naver-map-container"} style={{ width: '100%', height: '80vh' }}>
          <NaverMap
            ref={mapRef}
            defaultCenter={{ lat: 36.530146, lng: 127.958192 }} // Default center position
            defaultZoom={2}
            onZoomChanged={() => {
              // if (mapRef.current) {
              //   const zoom = mapRef.current.getZoom();
              //   if (zoom && zoom < 11 && filtersRef.current.radius) {
              //     onSubmitFilterForm({ ...filtersRef.current, radius: undefined });
              //   }
              // }
            }}
            zoomControl={true} // Show zoom control
            mapTypeControl={true} // Show map type control
            scaleControl={true} // Show scale control
            logoControl={true} // Show logo control
          >
            {sellers.map((seller) => (
              <Marker
                key={seller.id}
                position={new naver.maps.LatLng(Number(seller.latitude), Number(seller.longitude))}
                icon={{
                  url: seller.isMessika
                    ? '/assets/img/map/marker/marker_01.png'
                    : '/assets/img/map/marker/marker_02.png',
                }}
                onClick={() => {

                  setSelectedStore(seller);
                  scrollToSeller(seller);
                  centerMapToCoordinates(Number(seller.latitude), Number(seller.longitude), 15, 0, 40);
                  // setInfoWindowPosition(new naver.maps.LatLng(Number(seller.latitude), Number(seller.longitude)))

                  // Open info window
                  openInfoWindow(seller);
                }}
              />
            ))}
            {/* {(infoWindowPosition && selectedStore) && (
              <InfoWindow
                position={infoWindowPosition}
                // onCloseClick={() => {
                //   setInfoWindowPosition(null)
                // }}
                zIndex={9999999}
                backgroundColor={"#ffffff"}
                content={`
                  <div class="iw_inner">
                    <h4>${selectedStore.name}</h4>
                    <p>${selectedStore.address}</p>
                  </div>
                `}
              ></InfoWindow>
            )} */}
          </NaverMap>
        </MapDiv>
        <ListSellers
          sellers={sellers}
          filters={filters}
          selectedStore={selectedStore}
          onSelectStore={onSelectStore}
        />
      </SellerPageStructure>
    </NavermapsProvider>
  );
};

export default NaverMapSellersPage;
